import AnnouncementDesigner from '@admin/components/announcement_designer'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

class Design extends React.Component {

  static contextTypes = {
    network: PropTypes.object
  }

  static propTypes = {
    announcement: PropTypes.object,
    version: PropTypes.object
  }

  _handleSave = this._handleSave.bind(this)

  render() {
    return <AnnouncementDesigner { ...this._getAnnouncementDesigner() } />
  }

  _getAnnouncementDesigner() {
    const { version } = this.props
    return {
      defaultValue: version.value,
      onSave: this._handleSave
    }
  }

  _handleSave(value) {
    const { announcement } = this.props
    this.context.network.request({
      endpoint: `/api/admin/maha_announcements/${announcement.id}/config/versions`,
      method: 'PATCH',
      body: {
        publish: false,
        value
      }
    })
  }

}

const mapResourcesToPanel = (props, context) => ({
  version: `/api/admin/maha_announcements/${props.announcement.id}/config/versions/current`
})

const mapPropsToPanel = (props, context) => ({
  title: 't(Design)',
  component: <Design announcement={ props.announcement } version={ props.version } />
})

export default Panel(mapResourcesToPanel, mapPropsToPanel)
